//Following Functions can be used allover across application
//by simply importing;

import {
  COMMON_BH_SECTIONS,
  COMMON_DB_SECTIONS,
  DISTILLERY_BOILER_PATHS,
  EMPTY_GUID,
} from "constants/AppConstant";
import { COLOR_6 } from "constants/ChartConstant";
import { set } from "lodash";

//Function to getPagination config for Tables (Ant Desing Tables);
export const getPaginationProp = (i18n) => ({
  pageSizeOptions: ["10", "50", "100", "500", "1000"],
  showTotal: (total) => {
    const item = total > 1 ? "items" : "item";
    return `${i18n.t("Total")} ${total} ${i18n.t(item)}`;
  },
});

//Function to get Modal Props for Create or Edit Modal's;
export const getModalProps = (isLoading) => {
  return {
    closable: false,
    maskClosable: false,
    centered: true,
    cancelButtonProps: { disabled: isLoading },
    okButtonProps: { disabled: isLoading },
  };
};

//Function to get Array of Roles when there is no role for that
//company factory in case of Super Admin i.e. 'super@admin.com'
//Titles are translation keys: the menu translates every title when it renders, so these
//follow a language switch and match the menu groups (MenuGroups.js) in every language.
export const getNecessaryRoles = (i18n, lang_Key) => {
  return [
    {
      roleId: 1,
      parentId: 0,
      path: "isParent",
      title: "SoftwareAdministrator",
      isLeaveNode: false,
      isMenuPart: true,
      isHome: false,
      languageKey: lang_Key,
      icon: "UserOutlined",
    },
    {
      roleId: 2,
      parentId: 1,
      path: "Roles",
      title: "Roles",
      menuName: "Roles",
      isLeaveNode: true,
      isMenuPart: true,
      isHome: false,
      languageKey: lang_Key,
    },
    {
      roleId: 3,
      parentId: 1,
      path: "DataImportExport",
      title: "DataImportExport",
      menuName: "DataImportExport",
      isLeaveNode: true,
      isMenuPart: true,
      isHome: false,
      languageKey: lang_Key,
    },
    {
      roleId: 4,
      parentId: 1,
      path: "CloneDataUtility",
      title: "Clone Data Utility",
      menuName: "CloneDataUtility",
      isLeaveNode: true,
      isMenuPart: true,
      isHome: false,
      languageKey: lang_Key,
    },
    {
      roleId: 5,
      parentId: 1,
      path: "CommandDashboard",
      title: "CommandDashboard",
      menuName: "CommandDashboard",
      isLeaveNode: true,
      isMenuPart: true,
      isHome: false,
      languageKey: lang_Key,
    },
  ];
};

//Function to get Array of Role (Single Element) Configuration Role to Configure Roles, Categories  for that
//company factory in case of Super Admin i.e. 'super@admin.com'
export const getConfigurationRole = (i18n, lang_Key) => {
  return [
    {
      roleId: Date.now(),
      parentId: 0,
      path: "ConfigureFactoryPreRequisite",
      menuName: "ConfigurePreRequisite",
      title: "ConfigurePreRequisite",
      isLeaveNode: true,
      isHome: false,
      isMenuPart: true,
      languageKey: lang_Key,
      icon: "SettingOutlined",
    },
  ];
};

//Function to find sectionName of Front End Equipment Department when no more childRoles output will be RoleId (integer);
//when sectionName find output will be "CME", "CPE" (string);
export const findFEQ_BHSectionName = (roles, Id) => {
  let isSectionChange = true;
  const childRoles = roles.filter((x) => x.parentId == Id);
  let sectionNameOrId = Id;
  if (childRoles.length > 0) {
    for (var i = 0; i < childRoles.length; i++) {
      if (isSectionChange) {
        sectionNameOrId = findFEQ_BHSectionName(roles, childRoles[i].roleId);
        const type = typeof sectionNameOrId;
        if (type == "number") {
          const path = roles.find((x) => x.roleId == sectionNameOrId).path;
          if (path.indexOf("_") !== -1) {
            const result = path.substring(0, path.indexOf("_"));
            if (result == "CME") {
              isSectionChange = false;
              return "CME";
            } else if (result == "CPE") {
              isSectionChange = false;
              return "CPE";
            } else if (result == "CCE") {
              isSectionChange = false;
              return "CCE";
            } else if (result == "CHE") {
              isSectionChange = false;
              return "CHE";
            } else if (result == "PME") {
              isSectionChange = false;
              return "PME";
            } else if (result == "JHE") {
              isSectionChange = false;
              return "JHE";
            } else if (result == "EIE") {
              isSectionChange = false;
              return "EIE";
            } else if (result == "OCE") {
              isSectionChange = false;
              return "OCE";
            } else if (result == "OTH") {
              isSectionChange = false;
              return "OTH";
            } else if (result == "FBH") {
              isSectionChange = false;
              return "FBH";
            } else if (result == "VBBH") {
              isSectionChange = false;
              return "VBBH";
            } else if (result == "AHBH") {
              isSectionChange = false;
              return "AHBH";
            } else if (result == "EBH") {
              isSectionChange = false;
              return "EBH";
            } else if (result == "FABH") {
              isSectionChange = false;
              return "FABH";
            } else if (result == "CBH") {
              isSectionChange = false;
              return "CBH";
            }
            else if (result == "DSBH") {
              isSectionChange = false;
              return "DSBH";
            }
             else if (result == "FEBH") {
              isSectionChange = false;
              return "FEBH";
            } else if (result == "VBH") {
              isSectionChange = false;
              return "VBH";
            } else if (result == "ETBH") {
              isSectionChange = false;
              return "ETBH";
            } else if (result == "IBH") {
              isSectionChange = false;
              return "IBH";
            } else if (result == "FWBH") {
              isSectionChange = false;
              return "FWBH";
            } else if (result == "SDBH") {
              isSectionChange = false;
              return "SDBH";
            } else if (result == "WTBH") {
              isSectionChange = false;
              return "WTBH";
            } else if (result == "ASBH") {
              isSectionChange = false;
              return "ASBH";
            } else if (result == "SHBH") {
              isSectionChange = false;
              return "SHBH";
            } else if (result == "MSDP") {
              isSectionChange = false;
              return "MSDP";
            } else if (result == "USDP") {
              isSectionChange = false;
              return "USDP";
            } else if (result == "DDP") {
              isSectionChange = false;
              return "DDP";
            } else if (result == "PDP") {
              isSectionChange = false;
              return "PDP";
            } else if (result == "FDP") {
              isSectionChange = false;
              return "FDP";
            } else if (result == "DIDP") {
              isSectionChange = false;
              return "DIDP";
            } else if (result == "EPDP") {
              isSectionChange = false;
              return "EPDP";
            } else if (result == "IDP") {
              isSectionChange = false;
              return "IDP";
            } else if (result == "BDB") {
              isSectionChange = false;
              return "BDB";
            } else if (result == "BFDB") {
              isSectionChange = false;
              return "BFDB";
            } else if (result == "FDDB") {
              isSectionChange = false;
              return "FDDB";
            } else if (result == "SDB") {
              isSectionChange = false;
              return "SDB";
            } else if (result == "EPDB") {
              isSectionChange = false;
              return "EPDB";
            } else if (result == "IDB") {
              isSectionChange = false;
              return "IDB";
            } else if (result == "WTDB") {
              isSectionChange = false;
              return "WTDB";
            } else if (result == "FPDB") {
              isSectionChange = false;
              return "FPDB";
            } else if (result == "CPETP") {
              isSectionChange = false;
              return "CPETP";
            } else if (result == "FSEYP") {
              isSectionChange = false;
              return "FSETP";
            } else if (result == "ADETP") {
              isSectionChange = false;
              return "ADETP";
            } else if (result == "BRETP") {
              isSectionChange = false;
              return "BRETP";
            } else if (result == "DOETP") {
              isSectionChange = false;
              return "DOETP";
            } else if (result == "TPH") {
              isSectionChange = false;
              return "TPH";
            }else if (result == "DPH") {
              isSectionChange = false;
              return "DPH";
            }else if (result == "CTPH") {
              isSectionChange = false;
              return "CTPH";
            }
            else if (result == "GPH") {
              isSectionChange = false;
              return "GPH";
            } else if (result == "OHPH") {
              isSectionChange = false;
              return "OHPH";
            } else if (result == "EEPH") {
              isSectionChange = false;
              return "EEPH";
            } else if (result == "ICPH") {
              isSectionChange = false;
              return "ICPH";
            } else if (result == "JHCL") {
              isSectionChange = false;
              return "JHCL";
            } else if (result == "LSCL") {
              isSectionChange = false;
              return "LSCL";
            } else if (result == "DCL") {
              isSectionChange = false;
              return "DCL";
            } else if (result == "CCL") {
              isSectionChange = false;
              return "CCL";
            } else if (result == "FCL") {
              isSectionChange = false;
              return "FCL";
            } else if (result == "ECL") {
              isSectionChange = false;
              return "ECL";
            } else if (result == "CDCL") {
              isSectionChange = false;
              return "CDCL";
            } else if (result == "STCL") {
              isSectionChange = false;
              return "STCL";
            } else if (result == "EECL") {
              isSectionChange = false;
              return "EECL";
            } else if (result == "ICL") {
              isSectionChange = false;
              return "ICL";
            } else if (result == "PCR") {
              isSectionChange = false;
              return "PCR";
            } else if (result == "CCR") {
              isSectionChange = false;
              return "CCR";
            } else if (result == "COCR") {
              isSectionChange = false;
              return "COCR";
            } else if (result == "STCR") {
              isSectionChange = false;
              return "STCR";
            } else if (result == "CTCR") {
              isSectionChange = false;
              return "CTCR";
            } else if (result == "TRCR") {
              isSectionChange = false;
              return "TRCR";
            } else if (result == "ISCR") {
              isSectionChange = false;
              return "ISCR";
            } else if (result == "EECR") {
              isSectionChange = false;
              return "EECR";
            } else if (result == "ICR") {
              isSectionChange = false;
              return "ICR";
            } else if (result == "RCCT") {
              isSectionChange = false;
              return "RCCT";
            } else if (result == "RFCT") {
              isSectionChange = false;
              return "RFCT";
            } else if (result == "PCT") {
              isSectionChange = false;
              return "PCT";
            } else if (result == "SCCT") {
              isSectionChange = false;
              return "SCCT";
            } else if (result == "VCCT") {
              isSectionChange = false;
              return "VCCT";
            } else if (result == "MTCT") {
              isSectionChange = false;
              return "MTCT";
            } else if (result == "MMCT") {
              isSectionChange = false;
              return "MMCT";
            } else if (result == "RTCT") {
              isSectionChange = false;
              return "RTCT";
            } else if (result == "RCT") {
              isSectionChange = false;
              return "RCT";
            } else if (result == "EECT") {
              isSectionChange = false;
              return "EECT";
            } else if (result == "ICCT") {
              isSectionChange = false;
              return "ICCT";
            } else if (result == "HBA") {
              isSectionChange = false;
              return "HBA";
            } else if (result == "DBA") {
              isSectionChange = false;
              return "DBA";
            } else if (result == "RBBA") {
              isSectionChange = false;
              return "RBBA";
            } else if (result == "DCBA") {
              isSectionChange = false;
              return "DCBA";
            } else if (result == "SEBA") {
              isSectionChange = false;
              return "SEBA";
            } else if (result == "GBA") {
              isSectionChange = false;
              return "GBA";
            } else if (result == "SBBA") {
              isSectionChange = false;
              return "SBBA";
            } else if (result == "BCBA") {
              isSectionChange = false;
              return "BCBA";
            } else if (result == "SSBA") {
              isSectionChange = false;
              return "SSBA";
            } else if (result == "EEBA") {
              isSectionChange = false;
              return "EEBA";
            } else if (result == "ICBA") {
              isSectionChange = false;
              return "ICBA";
            }
            
            else if (result == "EVAP") {
              isSectionChange = false;
              return "EVAP";
            }
            else if (result == "YRP") {
              isSectionChange = false;
              return "YRP";
            }
            else if (result == "FPP") {
              isSectionChange = false;
              return "FPP";
            }
            else if (result == "ESD") {
              isSectionChange = false;
              return "ESD";
            }
            else if (result == "WSFS") {
              isSectionChange = false;
              return "WSFS";
            }
            

          }
        }
      }
    }
  }
  return sectionNameOrId;
};
export const isFEQSection = (sectionName) => {
  return [
    "CME",
    "CPE",
    "CCE",
    "CHE",
    "EIE",
    "JHE",
    "PME",
    "OCE",
    "OTH",
  ].includes(sectionName);
};
export const IsCommonDistilleryBoilerSection = (roles, Id) => {
  let isSectionChange = true;
  const childRoles = roles.filter((x) => x.parentId == Id);
  let sectionNameOrId = Id;
  if (childRoles.length > 0) {
    for (var i = 0; i < childRoles.length; i++) {
      if (isSectionChange) {
        sectionNameOrId = findFEQ_BHSectionName(roles, childRoles[i].roleId);
        const type = typeof sectionNameOrId;
        if (type == "number") {
          const path = roles.find((x) => x.roleId == sectionNameOrId).path;
          if (path.indexOf("_") !== -1) {
            const result = path.substring(0, path.indexOf("_"));
            if (COMMON_DB_SECTIONS.includes(result)) {
              isSectionChange = false;
              return true;
            }
          }
        }
      }
    }
  }
  return sectionNameOrId;
};
export const IsCommonBoilerSection = (roles, Id) => {
  let isSectionChange = true;
  const childRoles = roles.filter((x) => x.parentId == Id);
  let sectionNameOrId = Id;
  if (childRoles.length > 0) {
    for (var i = 0; i < childRoles.length; i++) {
      if (isSectionChange) {
        sectionNameOrId = findSectionName(roles, childRoles[i].roleId);
        const type = typeof sectionNameOrId;
        if (type == "number") {
          const path = roles.find((x) => x.roleId == sectionNameOrId).path;
          if (path.indexOf("_") !== -1) {
            const result = path.substring(0, path.indexOf("_"));
            if (COMMON_BH_SECTIONS.includes(result)) {
              isSectionChange = false;
              return true;
            }
          }
        }
      }
    }
  }
  return sectionNameOrId;
};
//Function to toogle Query Params for Front End Quipment to show assemblyLine dropdown;
//at global level;
const BHPaths = [
  "FBH",
  "VBBH",
  "AHBH",
  "EBH",
  "FABH",
  "CBH",
  "DSBH",
  "FEBH",
  "VBH",
  "ETBH",
  "IBH",
  "FWBH",
  "SDBH",
  "WTBH",
  "ASBH",
  "SHBH",
];
const DBPaths = ["BDB", "BFDB", "FDDB", "SDB", "EPDB", "IDB", "WTDB", "FPDB"];
export const toggleHouseInURL = (
  searchParams,
  setSearchParams,
  userData,
  sectionName = null
) => {
  if (sectionName) {
    const type = typeof sectionName;
    const { setAssemblyLineId, millingLineId, boilerId, distilleryBoilerId } =
      userData;
    if (type !== "number") {
      if (isFEQSection(sectionName)) {
        setSearchParams({ house: "FEQ" });
        setAssemblyLineId(millingLineId);
      } else if (BHPaths.includes(sectionName)) {
        setSearchParams({ house: "BH" });
        setAssemblyLineId(boilerId);
      } else if (DBPaths.includes(sectionName)) {
        setSearchParams({ house: "DB" });
        setAssemblyLineId(distilleryBoilerId);
      } else if (["FEQ", "BH", "DB"].includes(searchParams.get("house"))) {
        searchParams.delete("house");
        setSearchParams({});
        setAssemblyLineId(EMPTY_GUID);
      }
    }
  }
};
export const changeBoilerIfCommonSection = (section, userData) => {
  const { setAssemblyLineId, boilerId, distilleryBoilerId } = userData;
  if (typeof section !== "string") return;
  if (section.endsWith("BH")) {
    if ([...COMMON_BH_SECTIONS].includes(section)) {
      setAssemblyLineId(EMPTY_GUID);
    } else if (BHPaths.includes(section)) {
      setAssemblyLineId(boilerId);
    }
  } else if (section.endsWith("DB")) {
    if (COMMON_DB_SECTIONS.includes(section)) {
      setAssemblyLineId(EMPTY_GUID);
    } else if (DBPaths.includes(section)) {
      setAssemblyLineId(distilleryBoilerId);
    }
  }
};
//Function to find sectionName of Department when no more childRoles output will be RoleId (integer);
//when sectionName find output will be "CME", "CPE" (string);
//This will be use to find section names of all departments;
export const findSectionName = (roles, Id) => {
  let isSectionChange = true;
  const childRoles = roles.filter((x) => x.parentId == Id);
  let sectionNameOrId = Id;
  if (childRoles.length > 0) {
    for (var i = 0; i < childRoles.length; i++) {
      if (isSectionChange) {
        sectionNameOrId = findSectionName(roles, childRoles[i].roleId);
        const type = typeof sectionNameOrId;
        if (type == "number") {
          const path = roles.find((x) => x.roleId == sectionNameOrId).path;
          if (path.indexOf("_") !== -1) {
            const result = path.substring(0, path.indexOf("_"));
            if (result == "CME") {
              isSectionChange = false;
              return "CME";
            } else if (result == "CPE") {
              isSectionChange = false;
              return "CPE";
            } else if (result == "CCE") {
              isSectionChange = false;
              return "CCE";
            } else if (result == "CHE") {
              isSectionChange = false;
              return "CHE";
            } else if (result == "PME") {
              isSectionChange = false;
              return "PME";
            } else if (result == "JHE") {
              isSectionChange = false;
              return "JHE";
            } else if (result == "EIE") {
              isSectionChange = false;
              return "EIE";
            } else if (result == "OCE") {
              isSectionChange = false;
              return "OCE";
            } else if (result == "OTH") {
              isSectionChange = false;
              return "OTH";
            } else if (result == "FBH") {
              isSectionChange = false;
              return "FBH";
            } else if (result == "VBBH") {
              isSectionChange = false;
              return "VBBH";
            } else if (result == "AHBH") {
              isSectionChange = false;
              return "AHBH";
            } else if (result == "EBH") {
              isSectionChange = false;
              return "EBH";
            } else if (result == "FABH") {
              isSectionChange = false;
              return "FABH";
            } else if (result == "CBH") {
              isSectionChange = false;
              return "CBH";
            } else if (result == "DSBH") {
              isSectionChange = false;
              return "DSBH";
            } else if (result == "FEBH") {
              isSectionChange = false;
              return "FEBH";
            } else if (result == "VBH") {
              isSectionChange = false;
              return "VBH";
            } else if (result == "ETBH") {
              isSectionChange = false;
              return "ETBH";
            } else if (result == "IBH") {
              isSectionChange = false;
              return "IBH";
            } else if (result == "FWBH") {
              isSectionChange = false;
              return "FWBH";
            } else if (result == "SDBH") {
              isSectionChange = false;
              return "SDBH";
            } else if (result == "WTBH") {
              isSectionChange = false;
              return "WTBH";
            } else if (result == "ASBH") {
              isSectionChange = false;
              return "ASBH";
            } else if (result == "SHBH") {
              isSectionChange = false;
              return "SHBH";
            } else if (result == "MSDP") {
              isSectionChange = false;
              return "MSDP";
            } else if (result == "USDP") {
              isSectionChange = false;
              return "USDP";
            } else if (result == "DDP") {
              isSectionChange = false;
              return "DDP";
            } else if (result == "PDP") {
              isSectionChange = false;
              return "PDP";
            } else if (result == "FDP") {
              isSectionChange = false;
              return "FDP";
            } else if (result == "DIDP") {
              isSectionChange = false;
              return "DIDP";
            } else if (result == "EPDP") {
              isSectionChange = false;
              return "EPDP";
            } else if (result == "IDP") {
              isSectionChange = false;
              return "IDP";
            } else if (result == "BDB") {
              isSectionChange = false;
              return "BDB";
            } else if (result == "BFDB") {
              isSectionChange = false;
              return "BFDB";
            } else if (result == "FDDB") {
              isSectionChange = false;
              return "FDDB";
            } else if (result == "SDB") {
              isSectionChange = false;
              return "SDB";
            } else if (result == "EPDB") {
              isSectionChange = false;
              return "EPDB";
            } else if (result == "IDB") {
              isSectionChange = false;
              return "IDB";
            } else if (result == "WTDB") {
              isSectionChange = false;
              return "WTDB";
            } else if (result == "FPDB") {
              isSectionChange = false;
              return "FPDB";
            } else if (result == "CPETP") {
              isSectionChange = false;
              return "CPETP";
            } else if (result == "FSEYP") {
              isSectionChange = false;
              return "FSETP";
            } else if (result == "ADETP") {
              isSectionChange = false;
              return "ADETP";
            } else if (result == "BRETP") {
              isSectionChange = false;
              return "BRETP";
            } else if (result == "DOETP") {
              isSectionChange = false;
              return "DOETP";
            } else if (result == "TPH") {
              isSectionChange = false;
              return "TPH";
            }else if (result == "DPH") {
              isSectionChange = false;
              return "DPH";
            }else if (result == "CTPH") {
              isSectionChange = false;
              return "CTPH";
            }
            else if (result == "GPH") {
              isSectionChange = false;
              return "GPH";
            } else if (result == "OHPH") {
              isSectionChange = false;
              return "OHPH";
            } else if (result == "EEPH") {
              isSectionChange = false;
              return "EEPH";
            } else if (result == "ICPH") {
              isSectionChange = false;
              return "ICPH";
            }  else if (result == "JHCL") {
              isSectionChange = false;
              return "JHCL";
            } else if (result == "LSCL") {
              isSectionChange = false;
              return "LSCL";
            } else if (result == "DCL") {
              isSectionChange = false;
              return "DCL";
            } else if (result == "CCL") {
              isSectionChange = false;
              return "CCL";
            } else if (result == "FCL") {
              isSectionChange = false;
              return "FCL";
            } else if (result == "ECL") {
              isSectionChange = false;
              return "ECL";
            } else if (result == "CDCL") {
              isSectionChange = false;
              return "CDCL";
            } else if (result == "STCL") {
              isSectionChange = false;
              return "STCL";
            } else if (result == "EECL") {
              isSectionChange = false;
              return "EECL";
            } else if (result == "ICL") {
              isSectionChange = false;
              return "ICL";
            } else if (result == "PCR") {
              isSectionChange = false;
              return "PCR";
            } else if (result == "CCR") {
              isSectionChange = false;
              return "CCR";
            } else if (result == "COCR") {
              isSectionChange = false;
              return "COCR";
            } else if (result == "STCR") {
              isSectionChange = false;
              return "STCR";
            } else if (result == "CTCR") {
              isSectionChange = false;
              return "CTCR";
            } else if (result == "TRCR") {
              isSectionChange = false;
              return "TRCR";
            } else if (result == "ISCR") {
              isSectionChange = false;
              return "ISCR";
            } else if (result == "EECR") {
              isSectionChange = false;
              return "EECR";
            } else if (result == "ICR") {
              isSectionChange = false;
              return "ICR";
            } else if (result == "RCCT") {
              isSectionChange = false;
              return "RCCT";
            } else if (result == "RFCT") {
              isSectionChange = false;
              return "RFCT";
            } else if (result == "PCT") {
              isSectionChange = false;
              return "PCT";
            } else if (result == "SCCT") {
              isSectionChange = false;
              return "SCCT";
            } else if (result == "VCCT") {
              isSectionChange = false;
              return "VCCT";
            } else if (result == "MTCT") {
              isSectionChange = false;
              return "MTCT";
            } else if (result == "MMCT") {
              isSectionChange = false;
              return "MMCT";
            } else if (result == "RTCT") {
              isSectionChange = false;
              return "RTCT";
            } else if (result == "RCT") {
              isSectionChange = false;
              return "RCT";
            } else if (result == "EECT") {
              isSectionChange = false;
              return "EECT";
            } else if (result == "ICCT") {
              isSectionChange = false;
              return "ICCT";
            } else if (result == "HBA") {
              isSectionChange = false;
              return "HBA";
            } else if (result == "DBA") {
              isSectionChange = false;
              return "DBA";
            } else if (result == "RBBA") {
              isSectionChange = false;
              return "RBBA";
            } else if (result == "DCBA") {
              isSectionChange = false;
              return "DCBA";
            } else if (result == "SEBA") {
              isSectionChange = false;
              return "SEBA";
            } else if (result == "GBA") {
              isSectionChange = false;
              return "GBA";
            } else if (result == "SBBA") {
              isSectionChange = false;
              return "SBBA";
            } else if (result == "BCBA") {
              isSectionChange = false;
              return "BCBA";
            } else if (result == "SSBA") {
              isSectionChange = false;
              return "SSBA";
            } else if (result == "EEBA") {
              isSectionChange = false;
              return "EEBA";
            } else if (result == "ICBA") {
              isSectionChange = false;
              return "ICBA";
            }
             else if (result == "EVAP") {
              isSectionChange = false;
              return "EVAP";
            }
            else if (result == "YRP") {
              isSectionChange = false;
              return "YRP";
            }
            else if (result == "FPP") {
              isSectionChange = false;
              return "FPP";
            }
            else if (result == "ESD") {
              isSectionChange = false;
              return "ESD";
            }
            else if (result == "WSFS") {
              isSectionChange = false;
              return "WSFS";
            }
          }
        }
      }
    }
  }
  return sectionNameOrId;
};
/**
 * Role list for reading department / section codes (getDepartmentCode, findSectionName,
 * findFEQ_BHSectionName). Those codes come from the screens' paths below a section, but the
 * user's own grants (`newRoles` / `factoryRoles`) often leave those screens out, so a
 * department or section the user can pick resolves to no code (Milling Line stays disabled,
 * the API gets an undefined departmentName). The hierarchy list (useHierarchyDropdowns /
 * a screen's department list) keeps each section's whole subtree, so it goes first; the
 * grant rows it lacks are kept after it, so anything that resolved before still resolves.
 * @param {Array} hierarchyRoles - Department/section tree the screen's dropdowns are built from
 * @param {Array} grantedRoles - The user's own roles (userData.factoryRoles / newRoles)
 * @returns {Array} - hierarchyRoles followed by the grantedRoles rows it does not contain
 */
export const rolesForCodeLookup = (hierarchyRoles, grantedRoles) => {
  const primary = Array.isArray(hierarchyRoles) ? hierarchyRoles : [];
  const fallback = Array.isArray(grantedRoles) ? grantedRoles : [];
  if (primary.length === 0) return fallback;
  const seen = new Set(primary.map((x) => String(x.roleId)));
  return primary.concat(fallback.filter((x) => !seen.has(String(x.roleId))));
};
/**
 * Function to get Department Code from Roles when there is no role for that
 * company factory in case of Super Admin i.e. 'super@admin.com'
 * @param {Array} roles - Array of Roles
 * @param {Number} Id - Role Id for which Department Code needs to be found
 * @returns {String} - Department Code will be "FEQ" or "BH" based on Role Path
 */
export const getDepartmentCode = (roles, Id) => {
  const code = getDepartmentCodeFromPaths(roles, Id);
  if (typeof code === "string") {
    return code;
  }
  // A sub-department with no sections configured yet (e.g. Green Fuel's Process House
  // children) has no leaf paths to resolve from, so fall back to its title.
  const role = roles.find((x) => x.roleId == Id);
  const title = role && role.title ? role.title.trim().toLowerCase() : "";
  return SUB_DEPARTMENT_TITLE_CODES[title] || code;
};

// Department codes of sub-departments (Process House / Distillery children).
export const SUB_DEPARTMENT_CODES = ["CL", "CR", "CT", "BA", "DP", "DB", "ETP"];
const SUB_DEPARTMENT_TITLE_CODES = {
  clarification: "CL",
  crystallization: "CR",
  centrifugation: "CT",
  bagging: "BA",
  "distillery plant": "DP",
  "distillery boiler": "DB",
  "effluent treatment plant": "ETP",
};

/**
 * Sub-departments to list under a top-level house in a Department dropdown (as an OptGroup).
 * Children that resolve to a sub-department code are listed (Process House -> Clarification /
 * Crystallization / ..., Distillery -> Distillery Plant / ...), even when the house has only one
 * of them or they are not flagged isHome (Green Fuel). Otherwise falls back to the old rule of
 * 2+ isHome children. An empty result means the house itself is the selectable option.
 * @param {Array} roles - Array of Roles the dropdown is built from
 * @param {Number} houseId - roleId of the top-level house
 * @param {Array} [allRoles] - full role tree of the same factory, when `roles` is a filtered
 *   list (e.g. isHome only), so non-isHome sub-departments and their codes can be found
 * @returns {Array} - child roles to show under the house
 */
export const getSubDepartments = (roles, houseId, allRoles) => {
  const tree = allRoles && allRoles.length ? allRoles : roles || [];
  const children = tree.filter((d) => d.parentId === houseId);
  const subDepartments = children.filter((d) =>
    SUB_DEPARTMENT_CODES.includes(getDepartmentCode(tree, d.roleId))
  );
  if (subDepartments.length > 0) {
    return subDepartments;
  }
  const homeChildren = children.filter((d) => d.isHome == true);
  return homeChildren.length > 1 ? homeChildren : [];
};

const getDepartmentCodeFromPaths = (roles, Id) => {
  let isDepChange = true;
  const childRoles = roles.filter((x) => x.parentId == Id);
  let depNameOrId = Id;
  if (childRoles.length > 0) {
    for (var i = 0; i < childRoles.length; i++) {
      if (isDepChange) {
        depNameOrId = getDepartmentCodeFromPaths(roles, childRoles[i].roleId);
        const type = typeof depNameOrId;
        if (type == "number") {
          const path = roles.find((x) => x.roleId == depNameOrId).path;
          if (path.indexOf("_") !== -1) {
            const result = path.substring(0, path.indexOf("_"));
            if (
              [
                "CME",
                "CPE",
                "CCE",
                "CHE",
                "PME",
                "JHE",
                "EIE",
                "OCE",
                "OTH",
              ].includes(result)
            ) {
              isDepChange = false;
              return "FEQ";
            } else if (
              [
                "FBH",
                "VBBH",
                "AHBH",
                "EBH",
                "FABH",
                "CBH",
                "DSBH",
                "FEBH",
                "VBH",
                "ETBH",
                "IBH",
                "FWBH",
                "SDBH",
                "WTBH",
                "ASBH",
                "SHBH",
              ].includes(result)
            ) {
              isDepChange = false;
              return "BH";
            } else if (
              [
                //"DSBH",
                "MSDP",
                "USDP",
                "DDP",
                "PDP",
                "FDP",
                "DIDP",
                "EPDP",
                "IDP",
                 "EVAP",
                "YRP",
                "FPP",
                "ESD",
                "WSFS",
              ].includes(result)
            ) {
              isDepChange = false;
              return "DP";
            } else if (
              [
                "BDB",
                "BFDB",
                "FDDB",
                "SDB",
                "EPDB",
                "IDB",
                "WTDB",
                "FPDB",
               
              ].includes(result)
            ) {
              isDepChange = false;
              return "DB";
            } else if (
              ["CPETP", "FSETP", "ADETP", "BRETP", "DOETP"].includes(result)
            ) {
              isDepChange = false;
              return "ETP";
            } else if (
              ["TPH", "GPH", "OHPH", "EEPH", "ICPH", "DPH", "CTPH"].includes(result)
            ) {
              isDepChange = false;
              return "PH";
            } else if (
              ["JHCL", "LSCL", "DCL", "CCL", "FCL", "ECL", "CDCL", "STCL", "EECL", "ICL"].includes(result)
            ) {
              isDepChange = false;
              return "CL";
            } else if (
              ["PCR", "CCR", "COCR", "STCR", "CTCR", "TRCR", "ISCR", "EECR", "ICR"].includes(result)
            ) {
              isDepChange = false;
              return "CR";
            } else if (
              ["RCCT", "RFCT", "PCT", "SCCT", "VCCT", "MTCT", "MMCT", "RTCT", "RCT", "EECT", "ICCT"].includes(result)
            ) {
              isDepChange = false;
              return "CT";
            } else if (
              ["HBA", "DBA", "RBBA", "DCBA", "SEBA", "GBA", "SBBA", "BCBA", "SSBA", "EEBA", "ICBA"].includes(result)
            ) {
              isDepChange = false;
              return "BA";
            }
          }
        }
      }
    }
  }
  return depNameOrId;
};
//This will return the color for progress bar according to given percentage;
export const getStrokeColor = (percent) => {
  const percentage = Math.floor(percent);
  if (percentage < 0) {
    return "#FF1F29"; // red
  } else if (percentage <= 25) {
    return "#FF1F29"; // red
  } else if (percentage <= 50) {
    return "#FFBF00";
  } else if (percentage <= 75) {
    return COLOR_6;
  } else {
    return "#006400"; // green
  }
};

//This will return the user defined the title for the give role's path;
//role path is developer defined (path = name of view file);
export const getRoleTitleByPath = (roles, path) => {
  return roles.find((x) => x.path == path).title;
};

// Title of the first of these screens that is in the factory's menu, undefined when none is.
// A report shown inside a workspace or the Performance Co-Relations hub may have no menu row
// of its own, so it is given its own path first and then the screens it is embedded in.
export const getFirstRoleTitleByPaths = (roles, paths) => {
  for (const path of paths) {
    const role = (roles || []).find((x) => x.path == path);
    if (role) return role.title;
  }
  return undefined;
};

// Best-effort classification of a notification's alert type from its title, using the same
// keyword rules as the alert engine's config types (Stoppage, Performance Correlation, Job Work
// Order, Inspection Threshold, Inspection Reminder, IIOT, Regime Test Reminder). Notifications
// don't carry an explicit type of their own, so this is what the Alerts Dashboard groups/filters by.
export const getAlertTypeFromTitle = (title) => {
  const t = (title || "").trim().toLowerCase();
  if (t === "inspection reminder") return "Inspection Reminder";
  if (t === "inspection threshold" || t.includes("critical spare") || t.includes("inspection threshold")) return "Inspection Threshold";
  if (t.includes("stoppage")) return "Stoppage";
  if (t.includes("job") || t.includes("work order")) return "Job Work Order";
  if (t.includes("performance")) return "Performance Correlation";
  if (t.includes("regime")) return "Regime Test Reminder";
  if (t.includes("iiot")) return "IIOT";
  if (t.includes("inspection")) return "Inspection Threshold";
  return "Other";
};

// Filters notifications list based on the enabled status of their matching alert configurations.
export const filterNotificationsByAlertStatus = (notificationsList, configs) => {
  if (!notificationsList || notificationsList.length === 0) return [];
  if (!configs || configs.length === 0) return notificationsList;
  
  const filtered = notificationsList.filter(item => {
    const title = (item.title || "").trim().toLowerCase();
    
    // Map notification titles to their EXACT corresponding alert type.
    // Each title maps to only ONE type so that disabling one type does not
    // affect notifications from a different type that shares a keyword.
    let mappedTypes = [];
    if (title === 'inspection reminder') {
      // Notifications titled exactly "Inspection Reminder" are produced by
      // the "Inspection Reminder" alert configuration type.
      mappedTypes = ['inspection reminder'];
    } else if (title === 'inspection threshold' || title.includes('critical spare') || title.includes('inspection threshold')) {
      // Notifications for critical-spare / threshold checks use
      // "Inspection Threshold" or "Critical Spare" config types.
      mappedTypes = ['inspection threshold', 'critical spare'];
    } else if (title.includes('stoppage') || title.includes('machine stoppage')) {
      mappedTypes = ['stoppage'];
    } else if (title.includes('job') || title.includes('work order')) {
      mappedTypes = ['job work order'];
    } else if (title.includes('performance')) {
      mappedTypes = ['performance correlation'];
    } else if (title.includes('regime')) {
      mappedTypes = ['regime test reminder'];
    } else if (title.includes('iiot')) {
      mappedTypes = ['iiot'];
    } else if (title.includes('inspection')) {
      // Generic inspection-related notifications fall back to inspection threshold.
      mappedTypes = ['inspection threshold', 'critical spare'];
    } else {
      // Unknown title – default to keeping it visible.
      return true;
    }

    const relatedConfigs = configs.filter(config =>
      mappedTypes.includes((config.alertType || "").toLowerCase())
    );

    // If no config exists for this type, show it by default.
    // If configs exist, show ONLY when at least one of them is enabled.
    if (relatedConfigs.length === 0) {
      return true;
    }
    return relatedConfigs.some(config => config.isEnabled);
  });

  // Preserve the reports collections on the first item to prevent UI crashes
  if (filtered.length > 0 && notificationsList.length > 0) {
    filtered[0].inspectionReports = notificationsList[0].inspectionReports;
    filtered[0].spareReports = notificationsList[0].spareReports;
    filtered[0].inspectionReportsDetail = notificationsList[0].inspectionReportsDetail;
  }

  return filtered;
};


/**
 * Section code (CME, CCE, FBH ...) -> the section's name in this factory's menu (QA live 13 Oct).
 * Reports get the section code from the server; the name is the title of the section's RolesNew row:
 * a direct child of a house, or of its sub-departments when it has them (Process House, Distillery).
 * The code of a section is read from the paths of the screens below it (findSectionName).
 * @param {Array} roles - the factory's RolesNew rows (Hierarchy/FetchDepartmentSections)
 * @returns {Object} - { [code]: title }; a code with no section row is left out
 */
export const getSectionTitlesByCode = (roles = []) => {
  const list = roles || [];
  const map = {};
  list
    .filter((x) => x.parentId == 0 && x.isHome == true)
    .forEach((house) => {
      const subDepartments = getSubDepartments(list, house.roleId);
      const parents = subDepartments.length > 0 ? subDepartments : [house];
      parents.forEach((parent) =>
        list
          .filter((x) => x.parentId == parent.roleId)
          .forEach((section) => {
            const code = findSectionName(list, section.roleId);
            if (typeof code === "string" && section.title && !map[code]) map[code] = section.title;
          }),
      );
    });
  return map;
};

/**
 * The currency of a factory's demand plan rows (PlanCompleted.Currency, set on the Annual Plan):
 * the one most rows use. SEMMAPP has no currency per factory, so the plan's own currency is used;
 * "" when no row has one, so screens show the amount alone instead of "undefined" or a fixed "PKR".
 */
export const getPlanCurrency = (rows = []) => {
  const counts = {};
  (rows || []).forEach((r) => {
    const c = typeof r?.currency === "string" ? r.currency.trim() : "";
    if (c) counts[c] = (counts[c] || 0) + 1;
  });
  return Object.keys(counts).sort((a, b) => counts[b] - counts[a] || a.localeCompare(b))[0] || "";
};

// "1,234 Rs", or "1,234" when the currency is not known
export const withCurrency = (amount, currency) => (currency ? `${amount} ${currency}` : `${amount}`);
